import React from "react";
import AppBar from "@mui/material/AppBar";
import { Box, Stack, Toolbar, useTheme } from "@mui/material";
import BirdIcon from "../../assets/icon/bird-icon.svg";
import { Link } from "react-router-dom";
import NavigationBarAccountMenu from "./NavigationBarAccountMenu";
import InfoBar from "../TechStatus/InfoBar";
import { ALGOLIA_INDEX } from "../../config/_entrypoint";
import NavigationBarNotifications from "./NavigationBarNotifications";
import NavigationBarPresence from "./NavigationBarPresence/NavigationBarPresence";
import { isInternalUser, userHasRole } from "../../services/backofficeUserService";
import { Roles } from "../../types/BackofficeUser";
import { Hit } from "@algolia/client-search";
import SearchBar from "../Algolia/SearchBar";
import MainSearchHit from "../Case/CaseEntityPicker/Hit/MainSearchHit";
import navigationBarStyle from "./navigationBarStyle";
import { useCurrentUser } from "../../provider/CurrentUserProvider";
import ImpersonateInfo from "../Impersonate/ImpersonateInfo";

const NavigationBar = ({
  postSearchFilter = (hits: Array<Hit<any>>) => hits,
}: {
  postSearchFilter?: (hits: Array<Hit<any>>) => Array<Hit<any>>;
}) => {
  const currentUser = useCurrentUser();
  return (
    <AppBar position={"sticky"} color={"inherit"} className={"mui-fixed"} style={{ boxSizing: "content-box" }}>
      <InfoBar />
      <Toolbar sx={navigationBarStyle.toolbar}>
        <Stack
          direction={"row"}
          sx={{
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box component={Link} to={"/"}>
            <Box component="img" sx={navigationBarStyle.navBarIcon} src={BirdIcon} alt={"Legalbird"} />
          </Box>
          <Box
            sx={{
              flexGrow: 1,
            }}
          >
            <Box
              sx={{
                margin: "auto",
                minWidth: "300px",
                maxWidth: "800px",
              }}
            >
              <SearchBar
                HitComponent={MainSearchHit}
                resultListConfig={{
                  itemSize: 270,
                  height: Math.round(window.innerHeight * 0.8),
                }}
                searchConfig={{
                  indexName: ALGOLIA_INDEX,
                  postSearchFilter: postSearchFilter,
                }}
              />
            </Box>
          </Box>
          <Box>
            <Stack
              direction={"row"}
              sx={{
                justifyContent: "flex-end",
              }}
            >
              {isInternalUser(currentUser) && (
                <Box>
                  <NavigationBarPresence />
                </Box>
              )}
              {!userHasRole(currentUser, Roles.callcenter) && (
                <Box>
                  <NavigationBarNotifications />
                </Box>
              )}
              <Box>
                <NavigationBarAccountMenu />
              </Box>
            </Stack>
          </Box>
        </Stack>
      </Toolbar>
      <ImpersonateInfo />
    </AppBar>
  );
};
export default NavigationBar;
